<!-- <div
    *ngIf="organisationService && organisationService.activeItem && product"
    class="two-columns-noMargin"
>
    <div>
        <h1 style="font-weight: 600;">Produkt anlegen</h1>
        <div class="mini-grid-product-type">
            <mat-form-field>
                <input
                    matInput
                    placeholder="Hersteller"
                    [value]="organisationService.activeItem.organisationName"
                    disabled
                />
            </mat-form-field>
            <mat-form-field>
                <mat-select
                    placeholder="Produktkategorie"
                    [(ngModel)]="product.category"
                    #productCategory="ngModel"
                    required
                >
                    <mat-option *ngFor="let category of categories" [value]="category.value">
                        {{ category.name }}
                    </mat-option>
                </mat-select>
                <mat-error
                    *ngIf="productCategory.errors?.required && productCategory.touched"
                >
                    Diese Angabe ist erforderlich
                </mat-error>
            </mat-form-field>
        </div>
        <form #productForm="ngForm" autocomplete="off">
            <mat-form-field
                class="fullWidth product-name"
                hintLabel="Keine schon vorhandenen Produktnamen oder Sonderzeichen"
            >
                <input
                    matInput
                    [(ngModel)]="product.name"
                    placeholder="Produktname"
                    name="productName"
                    required
                    #productNameCtrl="ngModel"
                    [errorStateMatcher]="productNameErrorStateMatcher"
                    maxlength="161"
                    [ngModelOptions]="{ updateOn: 'change' }"
                />
                <mat-error>
                    {{ utilService.getErrorMessage(productNameCtrl, {includeMinLength: true, fieldName: 'Produkt'}) }}
                </mat-error>
            </mat-form-field>
            <app-text-editor
                [(editorText)]="product.description"
                (textValidityChange)="onDescriptionValidityChange($event)"
            ></app-text-editor>
            <mat-form-field class="fullWidth url">
                <input
                    matInput
                    [(ngModel)]="product.url"
                    placeholder="URL"
                    name="url"
                />
            </mat-form-field>

            <mat-form-field class="fullWidth url">
                <input
                    matInput
                    [(ngModel)]="product.slogan"
                    placeholder="Slogan"
                    name="slogan"
                />
            </mat-form-field>

            <addEntriesToList-panel
                [(keywords)]="featureArray"
                [editable]="true"
                [keywordPanel]="false"
            >
            </addEntriesToList-panel>

            <div>
                <app-add-product-dependency-panel
                    [product]="product"
                    [isCreate]="true"
                ></app-add-product-dependency-panel>

                <app-selected-product-panel
                    [hidden]="product.relatedProducts.length === 0"
                    [product]="product"
                >
                </app-selected-product-panel>
            </div>

            <div class="commonFeatureSelection">
                <p><b>Allgemeine Merkmale</b></p>
                <button
                    class="btn_green"
                    mat-raised-button
                    (click)="showCommonFeatureSelectionDialog()"
                >
                    Auswählen
                </button>
            </div>

            <div>
                <p>
                    <em>
                        Zum Anlegen eines Produkts ist das Anlegen einer
                        Variante sowie einer dazugehörigen Version notwendig
                    </em>
                </p>
                <div style="margin-bottom: 12px;">
                    <mat-form-field class="fullWidth">
                        <input
                            matInput
                            placeholder="Variantenname"
                            name="variantName"
                            #variantNameCtrl="ngModel"
                            [(ngModel)]="product.productVariants[0].name"
                            required
                            [errorStateMatcher]="variantNameErrorStateMatcher"
                            maxlength="161"
                            [ngModelOptions]="{ updateOn: 'change' }"
                        />
                        <mat-error>
                            {{ utilService.getErrorMessage(variantNameCtrl, {fieldName:'Varianten'}) }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <app-version-edit
                    [version]="product.productVariants[0].variantVersions[0]"
                    [dataType]="'PRODUCT'"
                    (validityChanged)="onValidityChanged($event)"
                ></app-version-edit>
            </div>

            <div class="mini-grid-buttons">
                <button
                    id="savebtn"
                    mat-raised-button
                    class="btn_green"
                    [disabled]="isSaveDisabled()"
                    (click)="createProduct()"
                >
                    Speichern
                </button>
                <button
                    mat-raised-button
                    class="btn_red"
                    (click)="cancelCreateProduct()"
                >
                    Abbrechen
                </button>
            </div>
        </form>
    </div>

    <div>
        <app-logo
            [fileId]="product.fileId"
            (logoChanged)="product.fileId = $event"
        ></app-logo>
        <app-product-files
            [documentFileIds]="product.documentFileIds"
            [galleryFileIds]="product.galleryFileIds"
            [logoId]="product.fileId"
            [galleryTitle]="'Produktgalerie'"
            (logoChanged)="product.fileId = $event"
        ></app-product-files>
    </div>
</div>
 -->
<div *ngIf="organisationService && organisationService.activeItem && product">
  <div class="stepper-wrapper-container">
    <!-- Stepper wrapper -->
    <mat-horizontal-stepper #stepper [linear]="true" labelPosition="bottom" class="stepper-container"
      (selectionChange)="onStepChange($event)">
      <mat-step [completed]="isDetailsStepComplete()">
        <ng-template matStepLabel>Grunddaten</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent" [disabled]="!isDetailsStepComplete()"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>
            Vorschau
          </button>
        </div>

        <div class="mini-grid-product-type mg-btm">
          <mat-form-field>
            <input matInput placeholder="Hersteller" [value]="organisationService.activeItem.organisationName"
              disabled />
          </mat-form-field>

          <mat-form-field>
            <mat-label>Produktkategorie</mat-label>
            <mat-select [(ngModel)]="product.category" #productCategory="ngModel" #productCategorySelect="matSelect"
              required (selectionChange)="onCategoryChange($event.value)">
              <ng-container *ngFor="let category of categoryService.categories$ | async">
                <mat-option *ngIf="category.filterOption" [value]="category.name">
                  {{ category.name }}
                </mat-option>
              </ng-container>
            </mat-select>
            <mat-error *ngIf="productCategory.errors?.required && productCategory.touched">
              Diese Angabe ist erforderlich
            </mat-error>
          </mat-form-field>
        </div>

        <form #productForm="ngForm" autocomplete="off" class="product-form">
          <mat-form-field class="fullWidth" hintLabel="Keine schon vorhandenen Produktnamen oder Sonderzeichen">
            <mat-label>Produktname</mat-label>
            <input matInput [(ngModel)]="product.name" name="productName" required #productNameCtrl="ngModel"
              [errorStateMatcher]="productNameErrorStateMatcher" maxlength="161" minlength="2"
              [ngModelOptions]="{ updateOn: 'change' }" (blur)="product.name = product.name.trim()" />
            <mat-error>
              {{ utilService.getErrorMessage(productNameCtrl, {includeMinLength: true, fieldName: 'Produkt'}) }}
            </mat-error>
          </mat-form-field>

          <app-text-editor [(editorText)]="product.description"
            (textValidityChange)="onDescriptionValidityChange($event)"></app-text-editor>

          <mat-form-field class="fullWidth url">
            <mat-label>Link zur Produktwebsite</mat-label>
            <input matInput [(ngModel)]="product.url" name="url" #productURL="ngModel" appUrlValidator type="url"
              required />
            <mat-error *ngIf="productURL.errors?.required">
              Diese Angabe ist erforderlich
            </mat-error>
            <mat-error *ngIf="productURL.hasError('websiteLength')">
              Die Website darf maximal 60 Zeichen lang sein
            </mat-error>
            <mat-error *ngIf="productURL.hasError('invalidUrl') && !productURL.hasError('websiteLength')">
              Bitte eine valide Website angeben
            </mat-error>
          </mat-form-field>

          <addEntriesToList-panel [(keywords)]="featureArray" [editable]="true" [keywordPanel]="false">
          </addEntriesToList-panel>
        </form>

        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="cancelCreateProduct()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <div></div>
          <button matButton="elevated" class="green-confirm" [disabled]="!isDetailsStepComplete()"
            (click)="onStepNext()" style="margin-top: 1vw;">
            Weiter
          </button>
        </div>
      </mat-step>

      <mat-step [completed]="product?.fileId">
        <ng-template matStepLabel>Gallerie & Dateien</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent" (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>

        <div>
          <app-logo [fileId]="product.fileId" [fullView]="true" (logoChanged)="product.fileId = $event"></app-logo>
          <app-product-files [documentFileIds]="product.documentFileIds" [galleryFileIds]="product.galleryFileIds"
            [logoId]="product.fileId" [galleryTitle]="'Produktgalerie'"
            (logoChanged)="product.fileId = $event"></app-product-files>
        </div>

        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="cancelCreateProduct()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <button matButton="elevated" color="accent" (click)="onStepPrevious()" style="margin-top: 1vw;">
            Zurück
          </button>
          <button matButton="elevated" class="green-confirm" [disabled]="!isGalleryStepComplete()"
            (click)="onStepNext()" style="margin-top: 1vw;">
            Weiter
          </button>
        </div>
      </mat-step>

      <mat-step [completed]="isVariantVersionStepComplete()">
        <ng-template matStepLabel>Variante & Versionen</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent" [disabled]="!isDetailsStepComplete()"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>

        <div style="margin-bottom: 12px;">
          <!-- <p><b>Variant Informationen</b></p> -->
          <mat-form-field class="fullWidth">
            <mat-label>Variantenname</mat-label>
            <input matInput name="variantName" #variantNameCtrl="ngModel" [(ngModel)]="product.productVariants[0].name"
              required [errorStateMatcher]="variantNameErrorStateMatcher" maxlength="161" minlength="2"
              [ngModelOptions]="{ updateOn: 'change' }" />
            <mat-icon matSuffix
              matTooltip="Varianten stehen ganz oben rechts auf der Produktübersichtsseite als Drop-Down Menü. Es kann mehrere Varianten für ein Produkt geben. Sie werden verwendet bei unterschiedlichen Produktausführungen für die gleiche Zielgruppe und unterscheiden sich z.b. in Preis und Funktionsumfang. Beispiele: Free, Standard, Professional, Enterprise oder Kostenfrei, Kostenpflichtig oder Concurrent User, Named User. Zusätzliche Versionen können Sie nach Bedarf im Bereich Einstellungen / Produkte ergänzen.​ Produkte für unterschiedliche Zielgruppen (Beispiel: Statiker, Architekt, Haustechnik, … ) bitte ebenfalls separat anlegen."
              matTooltipPosition="above" tabindex="-1" class="info-icon">
              info_outline
            </mat-icon>
            <mat-error>
              {{ utilService.getErrorMessage(variantNameCtrl, {fieldName:'Varianten', includeMinLength: true}) }}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="fullWidth">
            <mat-label>Variantenbeschreibung</mat-label>
            <input matInput name="variantDescription" #variantDescriptionCtrl="ngModel"
              [(ngModel)]="product.productVariants[0].description" required
              [errorStateMatcher]="descriptionVariantErrorStateMatcher" maxlength="1001" minlength="2"
              [ngModelOptions]="{ updateOn: 'change' }" />

            <mat-icon matSuffix class="info-icon" matTooltip="Maximale Zeichenanzahl 1000 Zeichen."
              matTooltipPosition="above" tabindex="-1">
              info_outline
            </mat-icon>

            <mat-error>
              {{ utilService.getErrorMessage(variantDescriptionCtrl, { maxLength: 1000,
              fieldDescription:'Variantenbeschreibung', includeMinLength: true}) }}
            </mat-error>
          </mat-form-field>
        </div>

        <app-version-edit [version]="product.productVariants[0].variantVersions[0]" [dataType]="'PRODUCT'"
          [selectedCategory]="selectedCategory" (validityChanged)="onValidityChanged($event)"></app-version-edit>

        <div style="margin-top: 3rem;" *ngIf="!isFirstProductPath">
          <!-- <p><b>Produktabhängigkeit</b></p> -->
          <h3>Produktabhängigkeit</h3>
          <app-add-product-dependency-panel [product]="product" [isCreate]="true"></app-add-product-dependency-panel>

          <app-selected-product-panel [hidden]="product.relatedProducts.length === 0" [product]="product">
          </app-selected-product-panel>
        </div>
        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="cancelCreateProduct()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <button matButton="elevated" class="green-confirm" (click)="onStepPrevious()"
            style="margin-top: 1vw;">Zurück</button>
          <button matButton="elevated" class="green-confirm" [disabled]="!isVariantVersionStepComplete()"
            (click)="onStepNext()" style="margin-top: 1vw;">
            Weiter
          </button>
        </div>
      </mat-step>


      <mat-step [completed]="isCommonFeatureStepValid()">
        <ng-template matStepLabel>Übergeordnete Auswahlkriterien</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <div></div>
          <button matButton="elevated" color="accent" [disabled]="!isDetailsStepComplete()"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>

        <div>
          <app-common-feature-product-creation [selected]="commonFeatures" [selectedCategory]="selectedCategory"
            (selectedChange)="onCommonFeaturesChanged($event)">
          </app-common-feature-product-creation>
        </div>

        <div class="mini-grid-buttons">
          <span class="info-txt">*Pflichtfeld</span>
          <button matButton="elevated" color="warn" (click)="cancelCreateProduct()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <button matButton="elevated" class="green-confirm" (click)="onStepPrevious()"
            style="margin-top: 1vw;">Zurück</button>
          <button matButton="elevated" class="green-confirm" [disabled]="!isCommonFeatureStepValid()"
            (click)="onStepNext()" style="margin-top: 1vw;">Weiter</button>
        </div>
      </mat-step>


      <mat-step>
        <ng-template matStepLabel>Zusammenfassung</ng-template>

        <div class="form-header">
          <h1>{{ formTitle }}</h1>
          <div></div>
          <button id="savebtn" matButton="elevated" color="accent" [disabled]="isSaveDisabled()"
            (click)="createProduct(false)">
            Speichern
          </button>
          <button matButton="elevated" color="accent" [disabled]="!isDetailsStepComplete()"
            (click)="openProductDetailsPageDialog('Produktübersicht')">
            <mat-icon>crop_free</mat-icon>Vorschau
          </button>
        </div>

        <p><em>Bitte prüfen Sie die Angaben und speichern Sie das Produkt.</em></p>

        <app-product-summary [product]="product" [productFeatures]="featureArray"
          [selectedCommonFeatures]="commonFeatures" [showPTG]="showSummary"></app-product-summary>

        <div class="mini-grid-buttons">
          <!-- <div><span class="info-txt">*Pflichtfeld</span></div> -->
          <button matButton="elevated" color="warn" (click)="cancelCreateProduct()" style="margin-top: 1vw;">
            Abbrechen
          </button>
          <div></div>
          <button matButton="elevated" class="green-confirm" style="margin-top: 1vw;"
            (click)="onStepPrevious()">Zurück</button>
          <button id="savebtn" matButton="elevated" class="green-confirm"
            [disabled]="isSaveDisabled() || !subscriptionId" (click)="createProduct(true)" style="margin-top: 1vw;">
            Veröffentlichen
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>

<div *ngIf="isLoading" class="loading-overlay-spinner">
  <mat-spinner></mat-spinner>
</div>